import React from 'react';
import classnames from 'classnames';
import { SimpleCheckbox } from '../Form/Checkbox/Checkbox';

interface HeaderProps<T> {
  items: T[];
  sortedItems: T[];
  selectedItems?: T[];
  disableSelectForRow?: (data: T) => boolean;
  onSelectAll?: () => void;
}

export function MultiSelectHeader<T>({
  items,
  sortedItems,
  selectedItems,
  onSelectAll,
  disableSelectForRow = () => false,
}: HeaderProps<T>): JSX.Element {
  return (
    <th
      key="multi_select"
      className={classnames('sortable-list__header sortable-list__multiselect-column', {
        'sortable-list__multiselect-column--disabled': sortedItems.every(disableSelectForRow),
      })}
    >
      {onSelectAll && (
        <SimpleCheckbox
          value={selectedItems?.length === items.filter((item) => !disableSelectForRow(item)).length}
          onChange={onSelectAll}
        />
      )}
    </th>
  );
}

interface CellProps<T> {
  row: T;
  index: number;
  selectedItems?: T[];
  disableSelectForRow?: (data: T) => boolean;
  forceCheckForRow?: (data: T) => boolean;
  partiallyCheckedRow?: (data: T) => boolean;
  handleOnRowCheck: (row: T, index: number) => void;
}

function isChecked<T extends { id?: string }>(row: T, selectedItems?: T[]): boolean {
  return !!selectedItems?.find((item) => {
    return row.id === item.id;
  });
}

export function MultiSelectCell<T extends { id?: string }>({
  row,
  index,
  selectedItems,
  handleOnRowCheck,
  disableSelectForRow = () => false,
  forceCheckForRow = () => false,
  partiallyCheckedRow = () => false,
}: CellProps<T>): JSX.Element {
  return (
    <td
      key="multiselect_column"
      className={classnames('sortable-list__cell sortable-list__multiselect-column', {
        'sortable-list__multiselect-column--disabled': disableSelectForRow(row),
        'sortable-list__multiselect-column--disabled-checked': disableSelectForRow(row) && forceCheckForRow(row),
      })}
    >
      <SimpleCheckbox
        value={forceCheckForRow(row) || isChecked(row, selectedItems)}
        readOnly={disableSelectForRow(row) && forceCheckForRow(row)}
        partiallyChecked={partiallyCheckedRow(row)}
        onChange={() => {
          handleOnRowCheck(row, index);
        }}
      />
    </td>
  );
}
